import { makeStyles } from '@material-ui/styles';
import { alpha } from '@material-ui/core/styles/colorManipulator';

export default makeStyles((theme) => ({
    logotype: {
        [theme.breakpoints.down('xs')]: {
            display: 'none'
        },
        marginTop: '12px',
        marginLeft: '5px'
    },
    appBar: {
        width: '100%',
        height: '70px',
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        })
    },
    toolbar: {
        padding: `0px ${theme.spacing(2)}px 0px ${theme.spacing(2)}px !important`,
        minHeight: '70px'
    },
    hide: {
        display: 'none'
    },
    grow: {
        flexGrow: 1
    },
    search: {
        position: 'relative',
        borderRadius: 25,
        paddingLeft: theme.spacing(2.5),
        width: 36,
        backgroundColor: alpha(theme.palette.common.black, 0),
        transition: theme.transitions.create(['background-color', 'width']),
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: alpha(theme.palette.common.black, 0.08)
        }
    },
    searchFocused: {
        backgroundColor: alpha(theme.palette.common.black, 0.08),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: 250
        }
    },
    searchIcon: {
        width: 36,
        right: 0,
        height: '100%',
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: theme.transitions.create('right'),
        '&:hover': {
            cursor: 'pointer'
        }
    },
    searchIconOpened: {
        right: theme.spacing(1.25)
    },
    inputRoot: {
        color: 'inherit',
        width: '100%'
    },
    inputInput: {
        height: 36,
        padding: 0,
        paddingRight: 36 + theme.spacing(1.25),
        width: '100%'
    },
    messageContent: {
        display: 'flex',
        flexDirection: 'column'
    },
    headerMenu: {
        marginTop: theme.spacing(7)
    },
    headerMenuList: {
        display: 'flex',
        flexDirection: 'column'
    },
    headerMenuItem: {
        '&:hover, &:focus': {
            backgroundColor: theme.palette.background.light
            // color: "white",
        }
    },
    headerMenuInstance: {
        background: 'white !important',
        borderRadius: '5px !important',
        color: '#4D4E4E !important',
        marginRight: '15px !important',
        textTransform: 'none',
        fontSize: `${theme.palette.textSizeLarge} !important`
    },
    backToDashboardButton: {
        background:
            'transparent linear-gradient(259deg, #FFB300 0%, #FF8800 100%) 0% 0% no-repeat padding-box',
        borderRadius: '5px !important',
        color: '#FFF !important',
        marginRight: '15px !important',
        textTransform: 'none',
        fontSize: `${theme.palette.textSizeLarge} !important`
    },
    headerMenuButtonSandwich: {
        marginLeft: 9,
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0
        },
        padding: theme.spacing(0.5)
    },
    headerMenuButtonCollapse: {
        marginRight: theme.spacing(2)
    },
    headerIcon: {
        fontSize: '28px',
        color: 'rgba(255, 255, 255, 1.0)'
    },
    headerIconCollapse: {
        color: 'white'
    },
    profileMenu: {
        minWidth: '160px'
    },
    profileMenuUser: {
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(1)
    },
    profileMenuItem: {
        color: theme.palette.text.hint
    },
    profileMenuIcon: {
        marginRight: theme.spacing(2),
        color: theme.palette.text.hint,
        '&:hover': {
            color: theme.palette.primary.main
        }
    },
    profileMenuLink: {
        fontSize: theme.palette.textSizeLarge,
        color: '#000 !important',
        textDecoration: 'none',
        '&:hover': {
            cursor: 'pointer'
        }
    },
    messageNotification: {
        height: 'auto',
        display: 'flex',
        alignItems: 'center',
        '&:hover, &:focus': {
            backgroundColor: theme.palette.background.light
        }
    },
    messageNotificationSide: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginRight: theme.spacing(2)
    },
    messageNotificationBodySide: {
        alignItems: 'flex-start',
        marginRight: 0
    },
    sendMessageButton: {
        margin: theme.spacing(4),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        textTransform: 'none'
    },
    sendButtonIcon: {
        marginLeft: theme.spacing(2)
    },
    purchaseBtn: {
        [theme.breakpoints.down('sm')]: {
            display: 'none'
        },
        marginRight: theme.spacing(3)
    },
    fontAwesomeIcon: {
        fontSize: '18px'
    },
    fontAwesomeUserIcon: {
        fontSize: '30px'
    },
    unreadBadge: {
        // boxShadow: '0px 0px 10px #FFC260'
    },
    profileLogo: {
        borderRadius: '50%'
    },
    clientName: {
        color: '#FFFFFF',
        fontSize: theme.palette.textSizeLarge,
        marginLeft: '9px'
    }
}));
